<template>
    <hts-modal
        :show="visible"
        :title="$t('labels.deleteBankAccount')"
        type="confirm"
        :content="$t('labels.confirmDeleteBankAccount')"
        @close="close"
        @confirm="() => handleDelete()" />
</template>

<script setup lang="ts">
const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables'])
const id = ref('')
const close = () => {
  visible.value = false
  emits('close')
}

const handleDelete = () => {
  const api = $url.settings.deleteBankAccount

  $api(api, { body: { ids: [id.value] } }).then((data: any) => {
    const resData: any = data?.data?.value
    if (resData?.success) {
      process.client && $toast().success($t('labels.deleteSuccess'))
      emits('refreshTables')
      close()
    }
  })
}

const open = (idBankAccount: string) => {
  id.value = idBankAccount
  visible.value = true
}

defineExpose({
  open
})
</script>
